import React, { useEffect, memo, useState, useMemo } from "react";
import { Link } from "react-router-dom";
import PaginationNew from "../Widgets/PaginationNew";
import './CommonTable.css';
import { toTitleCase } from './Helpers';
import { useNavigate } from "react-router-dom";

const CommonTable = ({
  formattedData,
  perPage,
  totalItems,
  currentPage,
  handler,
  isActionStricky,
  maxWidth = "150px",
  filters = null,
    onSort,
  sortField,
  sortOrder,
  hidePagination = false,
}) => {
  const navigation = useNavigate();

  const toCamelCase = (str) => {
    if (!str) {
      return "";
    }
    str = str.trim().replace(/\s+/g, " ");

    // Already a single word (e.g. dueDate, prospectNo, id)
    if (!str.includes(" ")) {
      return str;
    }

    return str
      .split(" ")
      .map((word, index) =>
        index === 0
          ? word.toLowerCase()
          : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
      )
      .join("");
  };

  const handleUrlClick = (col) => {
    console.log("ttt111 col = ", col);
    
    if (col.linkUrl) {
      navigation(col.linkUrl)

    }
  }

  console.log("hhh111 formattedData111 = ", formattedData);


  if (!formattedData || formattedData.length === 0) return (
    <>
    {filters &&
        <div className="card-body d-none d-md-block" style={{padding: "0px 0px 20px 0px"}}>
          <div >
            {filters}
          </div>
        </div>
      }
    <div className="text-center">No Records Found</div>
    </>
  );

  const tableHeaders = formattedData[0].data.map((col) => col.label);
  console.log('tableHeaders:::::', tableHeaders, formattedData)
  const truncateText = (text, length = 1000) => {
    if (!text) return "";
    return text.length > length ? text.slice(0, length) + "..." : text;
  };

  return (
    <>
    
     {filters &&
        <div className="card-body d-none d-md-block" style={{padding: "0px 0px 20px 0px"}}>
          <div >
            {filters}
          </div>
        </div>
      }
     <div className="table-container-wrapper">
      <div className="table-wrapper" style={{ maxHeight: "500px", overflow: "auto" }}>
        <table
          className="table table-hover mb-0 common-table"
          style={{ whiteSpace: "nowrap" }}
        >
          <thead className="custom-table-header">
            <tr>
              {formattedData[0].data.map((header, idx) => (
                // <th
                //   key={idx}
                 
                //   className={
                //     header.isStricky ? "sticky-first-column" : ""
                //   }
                //   style={{ fontWeight: 600,fontSize: "14px",color: "#26252F" }}
                // >
                //   {header?.label?.toUpperCase()}
                // </th>
                <th
    key={idx}
    className={
                    header.isStricky ? "sticky-first-column" : ""
                  }
    onClick={() => onSort?.(toCamelCase(header.field) || toCamelCase(header.label))}
    style={{
        cursor: "pointer",
        fontWeight: 600,
        fontSize: "14px",
        color: "#26252F"
    }}
>
  {header?.label?.toUpperCase()}

{(sortField === header.field || sortField === header.label) && (
    sortOrder === "asc" ? " ▲" : " ▼"
)}
</th>
              ))}

              {formattedData[0].isAction && (
                <th
                  className={
                    isActionStricky
                      ? "sticky-right sticky-action-column"
                      : ""
                  }
                  style={{ fontWeight: 600, backgroundColor: "#F3F3FA",textTransform: "uppercase",fontSize: "14px",color: "#26252F" }}
                >
                  Actions
                </th>
              )}
            </tr>
          </thead>

            <tbody>
              {formattedData.map((item, rowIndex) => (
                <tr key={rowIndex}>
                  {item.data.map((col, colIndex) => (
                    <td
                      key={colIndex}
                      // className={
                      //   col.label.trim() === "Status" && col.isStricky
                      //     ? "sticky-right sticky-status-column"
                      //     : col.isStricky
                      //       ? "sticky-first-column"
                      //       : ""
                      // }
                      className={
                        col.isStricky ? "sticky-first-column" : ""
                      }
                      style={{ fontWeight: 400, color: "#26252F", fontSize: "14px" }}
                    >
                      {col.label.trim() === "Status" ? (
                        <span
                          className={`status-badge status-${col.value?.toLowerCase()}`}
                        >
                          {col.value ? toTitleCase(col.Status=="APPROVED"?"COMPLETED":(col.value=="APPROVAL_PENDING" || col.value=="SUBMITTED")?"A PENDING":col.value=="QUERY_OPEN"?"In Query":col.value || '-') : "-"}
                        </span>
                      ) : col.isImage ? (
                        <img src={col.value} height="50" width="50" alt="field" />
                      ) : col.isLink ? (
                        // <Link to={col.linkUrl} style={{ textDecoration: "underline" }}>{col.value}</Link>
                        <span style={{ textDecoration: "underline",color:"#1675E0",cursor: "pointer",display: "-webkit-box",
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: "vertical",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            cursor: "pointer",
                            wordBreak: "break-word",
                            whiteSpace: "initial",
                            maxWidth: maxWidth, }} onClick={() => col.linkUrl?handleUrlClick(col):col.handleClick()}>{col.value}</span>
                        // <Link to={col.linkUrl}  state={{ value: "deepak singh" }} style={{ textDecoration: "underline" }}>{col.value}</Link>

                      ) : (
                        <span
                          title={col.value}
                          style={{
                            display: "-webkit-box",
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: "vertical",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            cursor: "pointer",
                            wordBreak: "break-word",
                            whiteSpace: "initial",
                            maxWidth: maxWidth,

 color:
      col.label?.toLowerCase().trim().replace(/\s+/g, " ") === "due date"
        ? (() => {
            if (!col.value) return "";

            const [day, month, year] = col.value.split("-");
            const dueDate = new Date(year, month - 1, day);
            dueDate.setHours(0, 0, 0, 0);

            const today = new Date();
            today.setHours(0, 0, 0, 0);

            return dueDate >= today ? "green" : "red";
          })()
        : "",
                          }}
                        >
                          {col.value ? truncateText(col.value) : "-"}
                        </span>
                      )}
                    </td>
                  ))}

                  {item.actionButtons && (
                    <td className={isActionStricky ? "sticky-right sticky-action-column" : ""}>
                      {item.actionButtons}
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
        </table>
      </div>
      {
        hidePagination ? null : (
<div className="pagination-wrapper">
        <PaginationNew
          perPage={perPage}
          totalItems={totalItems}
          currentPage={currentPage}
          handler={handler}
        />
      </div>
        )
      }
      
    </div>
    
    </>
   
  );
};

export default memo(CommonTable);
